<template>
  <div class="bg-white">
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :filename="`pdf_file_${$route.params.id}`"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-content-width="100%"
      ref="html2Pdf"
      @progress="onProgress($event)"
    >
      <section slot="pdf-content">
        <div id="pdf-content-area" class="p-3"></div>
      </section>
    </vue-html2pdf>
    <div class="action-btn-block p-1 border-b bg-yellow-200">
      <div class="px-10 w-full flex justify-between">
        <button @click="$router.go(-1)" class="btn">{{ $t('Back') }}</button>
        <div>
          <button @click="print('210mm', '297mm')" class="btn">A4</button>
          <template v-for="(size, index) in $store.state.settings.printer_sizes">
            <button :key="index" @click="print(size, '200mm')" class="btn">
              {{ size }}
            </button>
          </template>
        </div>
        <div>
          <button @click="generatePDF" class="btn">
            {{ $t('Download PDF File') }}
            <template v-if="pdfProgress > 0"> {{ pdfProgress }}% </template>
          </button>
          <loading :status="loading"></loading>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <loading :status="loading"></loading>
      <div id="content-to-pdf" class="invoice-box px-2 my-1">
        <div class="mb-1">
          <div class="text-center">
            <h2 class="text-3xl font-bold pb-2 tracking-wider uppercase">
              {{ $store.state.settings.name }}
              <small class="text-sm">
                <p>{{ $store.state.settings.phone }}</p>
                <p>{{ $store.state.settings.address }}</p>
              </small>
            </h2>
          </div>
        </div>
        <div class>
          <qr-code :size="100" :text="`${currentUrl}/track/${repair.tracking}`"></qr-code>
          <h4 class="text-1 font-bold py-2 tracking-wider uppercase">{{ $t('Invoice') }} #{{ repair.tracking }}</h4>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Status') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div class="font-semibold">
              {{ repair.status }}
            </div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Warranty') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.has_warranty ? $t('Yes') : $t('No') }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Invoice date') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.created_at }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Brand') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.brand }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Name') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.device.name }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Model') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.device.model }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Serial number') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.serial_number }}</div>
          </div>
        </div>
        <div class="flex justify-between my-2 border-t border-black border-dotted">
          <div class="w-full pt-2">
            <label class="block mb-1 font-bold text-xs uppercase tracking-wide">{{ $t('From') }}:</label>
            <div class="text-sm">
              <div>
                <strong>{{ $t('Name') }}:</strong>
                {{ repair.name | capitalize }}
              </div>
              <div>
                <strong>{{ $t('Email') }}:</strong>
                {{ repair.email }}
              </div>
              <div>
                <strong>{{ $t('Phone') }}:</strong>
                {{ repair.phone }}
              </div>
              <div>
                <strong>{{ $t('Address') }}:</strong>
                {{ repair.address }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            mt-2
            flex flex-wrap
            bg-gray-100
            -mx-1
            border-b border-t border-black
            py-2
            items-start
          "
        >
          <div class="flex-1 px-1">
            <p class="uppercase tracking-wide text-xs font-bold">{{ $t('Issues') }} ({{ repair.defects.length }})</p>
          </div>
          <div class="px-1 w-32 text-right">
            <p class="leading-none">
              <span class="block uppercase tracking-wide text-xs font-bold">{{ $t('Charges') }}</span>
            </p>
          </div>
        </div>
        <template v-if="repair.is_manual">
          <div
            class="
              flex flex-wrap
              -mx-1
              py-2
              border-b border-dotted border-black
            "
          >
            <div class="flex-1 px-1">
              <p class>1 - {{ repair.defects.title }}</p>
            </div>
            <div class="px-1 w-32 text-right">
              <p class>{{ repair.defects.price | currency }}</p>
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="repair.defects.length">
            <div
              :key="index"
              class="
              flex flex-wrap
              -mx-1
              py-2
              border-b border-dotted border-black
            "
              v-for="(defect, index) in repair.defects"
            >
              <div class="flex-1 px-1">
                <p class>{{ index + 1 }} - {{ defect.title }}</p>
              </div>
              <div class="px-1 w-32 text-right">
                <p class>{{ defect.price | currency }}</p>
              </div>
            </div>
          </template>
        </template>
        <div class="pt-2" v-if="$store.state.settings.terms_conditions">
          <div class="font-bold text-left">
            {{ $t('I acknowledge the following terms and conditions') }}
          </div>
          <p class="text-xs terms text-gray-900">{{ $store.state.settings.terms_conditions }}</p>
          <div class="flex justify-between">
            <div class="font-bold flex-1">
              {{ $t('Signature') }}<small>({{ $t('by') }} {{ repair.name | capitalize }})</small>
            </div>
            <div class="font-sm">------------------------------</div>
          </div>
        </div>
        <div class="pt-2">
          <div class="flex justify-between">
            <div class="font-bold text-right flex-1">{{ $t('Subtotal') }}</div>
            <div class="text-right w-40">
              <div>{{ repair.sub_total | currency }}</div>
            </div>
          </div>
          <div class="flex justify-between">
            <div class="font-bold text-right flex-1">
              {{ $t('Priority charges') }}
            </div>
            <div class="text-right w-40">
              <div>{{ repair.priority.extra_charge | currency }}</div>
            </div>
          </div>
          <div class="flex justify-between">
            <div class="font-bold text-right flex-1">{{ $t('Tax') }}</div>
            <div class="text-right w-40">
              <div>{{ repair.tax | currency }}</div>
            </div>
          </div>
          <div class="flex justify-between">
            <div class="font-bold text-right flex-1">{{ $t('Additional amount') }}</div>
            <div class="text-right w-40">
              <div>{{ repair.additional_amount | currency }}</div>
            </div>
          </div>
          <div class="flex justify-between">
            <div class="font-bold text-right flex-1">
              {{ $t('Payable amount') }}
            </div>
            <div class="text-right w-40">
              <div>{{ (repair.total_charges + repair.additional_amount) | currency }}</div>
            </div>
          </div>
        </div>
        <div class="py-2">
          <div class="flex justify-between">
            <div class="font-bold text-right flex-1">
              {{ $t('Prepaid amount') }}
            </div>
            <div class="text-right w-40">
              <div class="font-bold">{{ repair.pre_paid | currency }}</div>
            </div>
          </div>
          <div class="flex justify-between">
            <div class="font-bold text-right flex-1">
              {{ $t('Amount due') }}
            </div>
            <div class="text-right w-40">
              <div class="font-bold">{{ repair.due | currency }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueQRCodeComponent from 'vue-qrcode-component';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'Repair',
  metaInfo() {
    return {
      titleTemplate: this.$store.state.settings.name,
    };
  },
  components: { VueHtml2pdf, 'qr-code': VueQRCodeComponent },
  data() {
    return {
      loading: true,
      pdfProgress: 0,
      currentUrl: window.app.url,
      repair: {
        has_warranty: false,
        device: {
          model: null,
          name: null,
        },
        defects: [],
        priority: {},
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    onProgress(e) {
      this.pdfProgress = e;
    },
    generatePDF() {
      var x = document.getElementById('content-to-pdf').innerHTML;
      document.getElementById('pdf-content-area').innerHTML = x;
      this.$refs.html2Pdf.generatePdf();
    },
    print(w, h) {
      const element = document.createElement('style');
      element.innerHTML = `@page { margin: 0; size : ${w} ${h} }`;
      document.head.appendChild(element);
      window.print();
    },
    get() {
      axios
        .get(route('repair-orders.print', this.$route.params.id))
        .then((response) => {
          this.repair = response.data.repair;
          this.loading = false;
          setTimeout(() => {
            window.print();
          }, 3000);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped="">
.invoice-box {
  font-family: monospace;
  width: 80%;
  font-size: 12px;
}

@media print {
  .invoice-box {
    width: 100%;
  }

  .action-btn-block {
    display: none;
  }
}
</style>
